export class TranscodingSideEffect {
  constructor(
    public id: number,
    public name: string,
  ) {}
}
